"use client";

import React, { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
export default function TheEssenceOfBreath() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showText, setShowText] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    setIsLoaded(true);
    const timer = setTimeout(() => {
      setShowText(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <section id="the-essence-of-breath" className="relative h-screen w-full overflow-hidden bg-background">
      {/* Background Video */}
      <div className="absolute inset-0 z-0 select-none">
        <div className="relative h-full w-full">
          <video ref={videoRef} className="h-full w-full object-cover" autoPlay loop muted playsInline style={{
          objectFit: "cover",
          height: "100%",
          width: "100%"
        }}>
            <source src="https://videos.pexels.com/video-files/7578544/7578544-uhd_2560_1440_25fps.mp4" type="video/mp4" />
          </video>
          {/* Overlay */}
          <div className="absolute inset-0 bg-white/10 mix-blend-overlay" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center">
        {/* Main Heading */}
        <h1 className={cn("font-sans text-[12vw] font-thin leading-none tracking-tighter text-primary select-none transition-opacity duration-1000 ease-out", isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
          PāAWAN
        </h1>

        {/* Subheading and Tagline */}
        <div className={cn("mt-8 flex flex-col items-center gap-4 transition-all duration-1000 ease-out", showText ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <p className="text-xl font-light tracking-[0.2em] text-primary/80 uppercase sm:text-2xl md:text-3xl">
            Breathable Luxury
          </p>
          
          {/* Hindi Tagline */}
          <p className="font-serif text-lg text-primary/60 sm:text-xl">
            पावन पवन, उत्तम जीवन
          </p>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-12 left-1/2 flex -translate-x-1/2 flex-col items-center gap-2">
          <span className={cn("text-xs font-medium tracking-widest text-primary/40 uppercase transition-opacity duration-700 delay-1500", showText ? "opacity-100" : "opacity-0")}>
            Discover
          </span>
          <div className="h-16 w-[1px] overflow-hidden bg-primary/10">
            <div className="h-full w-full animate-[scroll-down_2s_ease-in-out_infinite] bg-primary/60" />
          </div>
        </div>
      </div>

      {/* Animation Styles */}
      <style jsx global>{`
        @keyframes scroll-down {
          0% {
            transform: translateY(-100%);
          }
          50% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(100%);
          }
        }
      `}</style>
    </section>;
}